<template>
  <div class="store-confirm">
    <!-- 收货信息 -->
    <div class="address-section">
      <h3 class="section-title">收货信息</h3>
      <div class="address-content">
        <div class="address-item">
          <span class="label">收货店名：</span>
          <span class="value">{{ departmentdata.department_name }}</span>
        </div>
        <div class="address-item">
          <span class="label">联系人：</span>
          <span class="value">{{ weComUserInfo.shop_clerk_info.name }}</span>
        </div>
        <div class="address-item">
          <span class="label">收货地址：</span>
          <span class="value">{{ departmentdata.shop_address }}</span>
          <!-- <span class="switch-btn">切换</span> -->
        </div>
      </div>
    </div>

    <!-- 订单备注 -->
    <div class="remark-section">
      <h3 class="section-title">订单备注</h3>
      <div class="remark-content">
        <textarea v-model="remark" class="remark-input" placeholder="输入给商家的留言" maxlength="200"></textarea>
        <div class="remark-count">{{ remark.length }}/200</div>
      </div>
    </div>

    <!-- 商品列表 -->
    <div class="goods-section">
      <div class="goods-item" v-for="(item, index) in goodsList" :key="index">
        <div class="goods-image">
          <img :src="comapi.getImageUrl(item.cover_image)" />
        </div>
        <div class="goods-info">
          <div class="goods-name">{{ item.product_name }}({{ item.spec_name }})</div>
          <div class="goods-spec">规格：{{ item.unit }}</div>
          <div class="goods-price-row">
            <div class="goods-price">￥{{ item.shop_purchase_price / 100 }}</div>
            <div class="goods-quantity">x{{ item.num }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 支付方式选择   pay_type 1-线上支付 2-线下支付-->
    <div class="pay-type-section">
      <h3 class="section-title">支付方式选择</h3>
      <div class="pay-type-content">
        <div class="pay-type-item" :class="{ 'active': payType === '1' }" @click="payType = '1'">
          线上支付
        </div>
        <div class="pay-type-item" :class="{ 'active': payType === '2' }" @click="payType = '2'">
          线下支付
        </div>
      </div>
    </div>
    <div class="height-page"></div>


    <!-- 提交按钮 -->
    <div class="submit-section">
      <div class="many_con">
        <div class="delivery_fee">
          运费：¥ {{ delivery_fee / 100 }}
        </div>
        <div class="total-section">
          <div class="total-label">合计：¥&nbsp;</div>
          <div class="total-price">{{ totalPrice / 100 }}</div>
        </div>
      </div>
      <button class="submit-btn" @click="submitOrder">提交订单</button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import comapi from "@/utils/api/com";
import storeapi from "@/utils/api/store";
import { showDialog } from "vant";
import { useRouter, useRoute } from 'vue-router';

const router = useRouter();
const route = useRoute();
const remark = ref('');

const goodsList = ref([]);

const totalPrice = ref(0);
const delivery_fee = ref(0);
const payType = ref("1");
const departmentdata = JSON.parse(localStorage.getItem("departmentdata")) || {};
const weComUserInfo = JSON.parse(localStorage.getItem("weComUserInfo")) || {};
onMounted(() => {
  goodsList.value = JSON.parse(localStorage.getItem("order_goods_list")) || [];
  storeapi.calculatePrice({
    items: goodsList.value
  }).then((res) => {
    if (res.code === 200) {
      totalPrice.value = res.data.total_money
      delivery_fee.value = res.data.delivery_fee
    }
  });
});

const submitOrder = () => {
  storeapi.createOrder({
    shop_uuid: departmentdata.department_uuid,
    delivery_name: weComUserInfo.shop_clerk_info.name,
    delivery_phone: weComUserInfo.shop_clerk_info.phone,
    delivery_address: departmentdata.shop_address,
    total_money: totalPrice.value,
    items: goodsList.value,
    remark: remark.value,
    pay_type: payType.value
  }).then((res) => {
    if (res.code === 200) {
      showDialog({
        title: "订单提交成功",
        message: "已提交订货信息！",
      }).then(() => {
        let localCart = JSON.parse(localStorage.getItem('cart_data_list')) || [];
        if (localCart && localCart.length > 0) {
          localCart = localCart.filter(item => !goodsList.value.some(product => product.product_sku_uuid === item.uuid));
          localStorage.setItem('cart_data_list', JSON.stringify(localCart));
        }
        router.push({ path: '/store_order_detail', query: { order_uuid: res.data.shop_order_uuid } });
      });
    }
  });
}



</script>

<style lang="less" scoped>
.store-confirm {
  background-color: #f5f5f5;
  min-height: 100vh;
  padding-bottom: 80px;
  padding: 17px;

  .section-title {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
  }

  .address-section {
    background-color: #fff;
    padding: 10px;
    margin-bottom: 10px;
    border-radius: 8px;

    .address-content {
      .address-item {
        margin-bottom: 8px;
        display: flex;
        align-items: center;

        .label {
          font-size: 14px;
          color: #666;
          width: 80px;
        }

        .value {
          font-size: 14px;
          color: #333;
          flex: 1;
        }

        .switch-btn {
          font-size: 14px;
          color: #ff7123;
          margin-left: 10px;
        }
      }
    }
  }

  .remark-section {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 10px;
    border-radius: 8px;

    .remark-content {
      position: relative;

      .remark-input {
        width: 100%;
        height: 80px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        padding: 10px;
        font-size: 14px;
        resize: none;
        outline: none;
        background: #F6F6F6;
      }

      .remark-count {
        position: absolute;
        bottom: 15px;
        right: 8px;
        font-size: 12px;
        color: #999;
      }
    }
  }

  .goods-section {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 10px;
    border-radius: 8px;

    .goods-item {
      display: flex;
      margin-bottom: 16px;

      .goods-image {
        width: 80px;
        height: 80px;
        margin-right: 12px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          border-radius: 4px;
        }
      }

      .goods-info {
        flex: 1;

        .goods-name {
          font-size: 14px;
          color: #333;
          margin-bottom: 4px;
        }

        .goods-spec {
          font-size: 12px;
          color: #999;
          margin-bottom: 8px;
        }

        .goods-price-row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .goods-price {
            font-size: 16px;
            color: #ff7123;
            font-weight: bold;
          }

          .goods-quantity {
            font-size: 14px;
            color: #666;
          }
        }
      }
    }
  }

  .pay-type-section {
    background-color: #fff;
    padding: 16px;
    margin-bottom: 10px;
    border-radius: 8px;

    .pay-type-content {
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .pay-type-item {
        margin-right: 16px;
      }

      .pay-type-item:last-child {
        margin-right: 0;
      }

      .pay-type-item {
        font-size: 14px;
        color: #333;
        cursor: pointer;
        padding: 8px 16px;
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        transition: all 0.3s ease-in-out;
      }

      .pay-type-item.active {
        background-color: #ff7123;
        color: #fff;
        border-color: #ff7123;
      }
    }
  }

  .height-page {
    height: 120px;
  }

  .submit-section {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #fff;
    padding: 16px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    .many_con{
     display: flex;
     justify-items: center;
     justify-content: space-between;
     align-items: center;
     .delivery_fee{
      font-size: 14px;
      color: #ff7123;
     }
    }
    .total-section {
      color: #ff7123;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      .total-label {
        font-size: 14px;
      }

      .total-price {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .submit-btn {
      width: 100%;
      height: 48px;
      background-color: #DCBB89;
      color: #fff;
      border: none;
      border-radius: 11px;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;

      &:active {
        opacity: 0.8;
      }
    }
  }
}
</style>